import { getRawInitData } from "@/shared/telegram";

import { apiPost, setReloginHandler } from "./client";
import { ApiError } from "./error";
import { clearToken, getToken, setToken } from "./token";

/**
 * Вход по `initData`.
 *
 * Поле тела называется `initData` — единственное camelCase-поле во всём API,
 * остальное snake_case. Ответ кладёт токен в поле `token` (не `access_token`).
 */
export async function login(): Promise<boolean> {
  const initData = getRawInitData();
  if (!initData) return false;

  try {
    const result = await apiPost("/api/v1/auth/telegram", { body: { initData } });
    setToken(result.token);
    return true;
  } catch (error) {
    // 403 при логине — пользователь заблокирован. Токен не выдадут ни сейчас,
    // ни при повторе, поэтому молчаливый цикл релогина здесь надо оборвать.
    if (error instanceof ApiError && error.code === "FORBIDDEN") clearToken();
    return false;
  }
}

export function isAuthenticated(): boolean {
  return getToken() !== null;
}

export function logout(): void {
  clearToken();
}

/**
 * Реакция на 401: один молчаливый релогин. Регистрируется здесь, а не в
 * клиенте, чтобы не возник цикл импорта `client → auth → client`.
 */
setReloginHandler(async () => {
  clearToken();
  return login();
});
